<template>
  <div>
    <header class="modal-header">
      We're sorry your current provider isn't meeting your expectations
    </header>
    <section class="modal-body">
      <p>
        What went wrong? Please let us know and we will find a new provider to service your home.
      </p>
    </section>
    <footer class="modal-footer">
      <LsButton text="ok" track-id="return_request_second_review-ok" @click="next" />
    </footer>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { mapActions } from 'vuex';
import { DISPUTE__GOTO_INITIAL_STEP } from '@/store/types';

export default {
  name: 'ReturnRequestSecondReview',
  components: {
    LsButton,
  },
  methods: {
    ...mapActions([DISPUTE__GOTO_INITIAL_STEP]),
    next() {
      this[DISPUTE__GOTO_INITIAL_STEP]();
    },
  },
};
</script>

<style lang="scss" scoped></style>
